import React, { useState,useEffect } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Accordion, AccordionSummary, AccordionDetails, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material";
import { Table } from "react-bootstrap";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Card from "@mui/material/Card";
// import Table from 'react-bootstrap/Table';
import { ThreeDots } from 'react-loader-spinner';
// import TableContainer from "@mui/material/TableContainer";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import XLSX from 'sheetjs-style';
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import Drop from "../../assets/images/upload.png";
import typography from "assets/theme/base/typography";
import { ToastContainer, toast } from 'react-toastify';
const { size } = typography;
import VisibilityIcon from '@mui/icons-material/Visibility';
// Soft UI Dashboard React components
import SoftInput from "components/SoftInput";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftBadge from "components/SoftBadge";
import SoftSelect from "components/SoftSelect";
import Grid from "@mui/material/Grid";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { authGetMaterial } from "assets/globalAPI/GlobalApi";
import { styled } from "@mui/system";
import { getDocNumList } from "assets/globalAPI/GlobalApi";
import { getMaterialListFromDoc } from "assets/globalAPI/GlobalApi";
import SoftButton from "components/SoftButton";

const StyledAccordion = styled(Accordion)({
    margin: "10px 0",
    backgroundColor: "#fff",
    border: "2px solid #e0e0e0",
    boxShadow: "none",
    "&:hover": {
      borderColor: "#bdbdbd",
      boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
    },
    "&.Mui-expanded": {
      margin: "10px 0",
    },
  });
  
  const StyledAccordionSummary = styled(AccordionSummary)({
    padding: "0 16px",
    fontFamily: 'serif',
    fontWeight: 400,
    color: "#424242",
    "&.Mui-expanded": {
      fontWeight: 700,
    },
  });
  
  const StyledAccordionDetails = styled(AccordionDetails)({
    padding: "8px 16px",
    color: "#757575",
    fontSize: "14px",
    backgroundColor: "#f9f9f9",
  });

  const StyledTableCell = styled(TableCell)({
    fontSize: "14px",
    fontWeight: 500,
    color: "#424242",
    borderBottom: "1px solid #e0e0e0",
  });
  
  const StyledTableHeadCell = styled(TableCell)({
    fontSize: "14px",
    fontWeight: 600,
    color: "#212121",
    borderBottom: "2px solid #bdbdbd",
  });

function SMaterialList(){
    const[userAccess,setUserAccess] = useState('');
    const[userEmail,setUserEmail] = useState('');
    const[userID,setUserID] = useState('');
    const[userid,setUser_ID] = useState('');
    const[userName,setUserName] = useState('');
    const[customerLoading,setCustomerLoading] = useState(false);
    const [expanded, setExpanded] = useState(null);
    const[documentDetails,setDocumentDetails] = useState([]);
    const[customerDetails,setCustomerDetails] = useState([]);

    useEffect(()=>{
        if (localStorage.getItem('userid_details')) { 
            let session = localStorage.getItem('userid_details');
      let userid_array =JSON.parse(session);
      let userid = userid_array.userid;
      let user_id = userid_array.id;
      let user_type = userid_array.user_type;
      let user_email = userid_array.email;
      let user_name = userid_array.name;
      setUserAccess(user_type);
      setUserID(userid);
      setUserEmail(user_email);
      setUser_ID(user_id);
      setUserName(user_name);

      const getAllDocNumbers = async () => {
        try {
            const data = {
                "action": 'getDocNo',
                "userid": userid,
                "user_type": user_type
            };
            console.log("the body goes here>> ", data);
            const response = await getDocNumList(data);
            const res = response.data;
            console.log("here is your doc nums>> ", res.document_no_list);
            
            if (res.status === "true") {
                // Avoid duplicates by checking if document_no already exists in documentDetails
                const details = res.document_no_list.reduce((acc, doc) => {
                    // Check if the document number already exists in the state
                    if (!acc.some(existingDoc => existingDoc.document_no === doc.document_no)) {
                        acc.push({
                            document_no: doc.document_no,
                            id: doc.id,
                            created_by: doc.created_by,
                        });
                    }
                    return acc;
                }, []);
    
                // Update state with new document details
                setDocumentDetails(details);
                console.log("details are now>>", details);
            }
        } catch (error) {
            console.log("Error fetching doc numbers>> ", error);
        }
    };
    
    getAllDocNumbers();

        }
    },[]);

    const handleAccordianChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false); // Close if it's already open
      };

    const fetchAllDetailsFromNumber=async(doc_no)=>{
        setCustomerDetails([])
        setCustomerLoading(true)
        const body ={"action":"getCustomer_safari","userid":userID,"user_type":userAccess,"document_no":doc_no,"user_id":userid}
        try{

            const response= await getMaterialListFromDoc(body);
            const res= response.data;
            console.log("here is ur material>> ", res)
            if(res.status==="true"){
                setCustomerDetails(res.customer_details)
                console.log("here is details of cus>> ", res.customer_details)
                setCustomerLoading(false)
            }else{
                setCustomerLoading(false)
            }
        }catch(error){
            console.log("error in material bringing>> ", err)
            setCustomerLoading(false);
        }
    }

    const capitalizeHeader = (header) => {
        return header
          .replace(/_/g, " ") // Replace underscores with spaces
          .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize the first letter of each word
      };


    return(
        <DashboardLayout>
            {/* <DashboardNavbar/> */}
            <ToastContainer/>
            <div style={{ padding: "20px" }}>
              <Card sx={{ padding: "20px", display: "flex", justifyContent: "space-between" }}>

              <SoftTypography fontFamily="serif" variant="h4" style={{ marginBottom: "20px" }}>Vendor List</SoftTypography>
              </Card>
            {documentDetails.map((doc) => (
        <StyledAccordion onChange={handleAccordianChange(doc.id)} expanded={expanded === doc.id} key={doc.id}>
          <StyledAccordionSummary
            expandIcon={<ExpandMoreIcon />}
            onClick={() => fetchAllDetailsFromNumber(doc.document_no)}
          >
            <span style={{color: "#67748e"}}>Document No: {doc.document_no}</span>
           
          </StyledAccordionSummary>
          <StyledAccordionDetails>
          {customerDetails.length === 0 ? (
              <div>
                {customerLoading? <p>Loading customer data...</p>: <p>No Records Found</p>}
                
              </div>
            ) : (
                <Table striped bordered hover responsive>
                <thead>
                  <tr>
                    {Object.keys(customerDetails[0])
                      .filter((key) => key !== "id") // Filter out the "id" field
                      .slice(0, Object.keys(customerDetails[0]).indexOf("division") ) // Limit to columns up to "division"
                      .map((key) => (
                        <th style={{ whiteSpace: "nowrap" }} key={key}>
                          {capitalizeHeader(key)} {/* Capitalize the headers */}
                        </th>
                      ))}
                  </tr>
                </thead>
                <tbody>
                  {customerDetails
                    .filter((customer) => customer.document_no === doc.document_no) // Filter by document_no
                    .map((customer, index) => (
                      <tr key={customer.id}>
                        {Object.entries(customer)
                          .filter(([key]) => key !== "id") // Filter out the "id" field here as well
                          .slice(0, Object.keys(customer).indexOf("division") ) // Limit to columns up to "division"
                          .map(([key, value], idx) => (
                            <td style={{ whiteSpace: "nowrap" }} key={idx}>
                              {value || "-"} {/* Display values or "-" if empty */}
                            </td>
                          ))}
                      </tr>
                    ))}
                </tbody>
              </Table>
              
            )}
             {userAccess === "Lev-1" && customerDetails.length > 0 &&(
              <div style={{ marginLeft: "auto", display: "flex", gap: "15px", padding:2 }}>
                <SoftButton variant="gradient" color="success">Approve</SoftButton>
                <SoftButton variant="gradient" color="error">Reject</SoftButton>
              </div>
            )}
          </StyledAccordionDetails>
        </StyledAccordion>
      ))}


    </div>
        </DashboardLayout>
    )

}

export default SMaterialList